<template lang="html">

  <article class="comunicacion-el" :style="ownstyle.comunicacion">
    <h3 class="fecha" :style="style.colorMediumBlack" v-html="data.fechaDesde"></h3>
    <h2 class="titulo" v-html="data.titulo"></h2>
    <p v-html="data.descripcion"></p>
    <arrow-link class="arrow-link" :text="$t('ver_mas')" :to="data.enlace" :external="true" :blank="true" v-if="!!data.enlace"></arrow-link>
  </article>

</template>

<script lang="js">

  import arrowLink from '@/components/parts/icons/arrow-link'

  import {mapGetters} from 'vuex';

  export default  {
    name: 'comunicacion-el',
    props: ['data'],
    components :{
      'arrow-link' : arrowLink
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles'
      }),
      ownstyle : function(){
        return {
          comunicacion : {
            'border-bottom' : `1px solid ${this.colors.medium_black}`
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.comunicacion-el {
  padding: 15px 0;
  width: 100%;
}

.comunicacion-el:last-of-type{
  border-bottom: none!important;
  padding-bottom: 0;
}

.titulo{
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  width: 100%;
  text-align: left;
}

.fecha{
  text-transform: uppercase;
  font-size: 14px;
  width: 100%;
  text-align: left;
  display: inline-block;
  font-weight: 600;
}

@media screen and (max-width: 768px){
  .comunicacion-el{
    width: calc(50% - 10px);
  }
}

@media screen and (max-width: 550px){
  .comunicacion-el{
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/home/comunicacion-el.vue